const orange = "#ee6917"
const purple = "#5449d3"
const blue = "#0c6ede"
const red = "#b11321"

const vehicleIncidentColorSet: Record<string, string> = {
  crash: orange,
  followingDistance: purple,
  lateResponse: purple,
  defensiveDriving: purple,
  nearCollison: purple,
  forwardCollisionWarning: red,
  nearPedestrianCollisions: purple,
  unsafeParking: purple,
  braking: orange,
  HardBraking: orange,
  harshTurn: orange,
  acceleration: orange,
  genericDistraction: blue,
  drowsy: blue,
  mobileUsage: blue,
  rollingStop: orange,
  ranRedLight: orange,
  laneDeparture: orange,
  didNotYield: orange,
  unsafeUTurn: orange,
  unsafeLeftTurn: orange,
  eatingDrinking: blue,
  noSeatbelt: blue,
  obstructedCamera: blue,
  unsafeReversing: blue,
  smoking: blue,
  speeding: orange,
  severeSpeeding: purple,
  maxSpeed: blue
}

export default vehicleIncidentColorSet